import { createSlice } from "@reduxjs/toolkit";

type AccountInfoState = {
  accountInfo: {
    customTheme?: string;
  } | null;
};

const initialState: AccountInfoState = {
  accountInfo: null,
};

const slice = createSlice({
  name: "AccountInfo",
  initialState,
  reducers: {
    setAccountInfo(state, action) {
      const { customTheme } = action.payload;
      state.accountInfo = { customTheme };
    },
    resetAccountInfo(state) {
      state.accountInfo = null;
    },
  },
});

export default slice.reducer;

// Actions
export const { setAccountInfo, resetAccountInfo } = slice.actions;
